export const environment = {
  production: true,  
  apiBase: 'https://theonestopradio.com/api/',
  // siteUrl: 'http://54.185.227.93', 
   siteUrl: 'https://theonestopradio.com/',
   devToolsProtection: true
};
